/**
 * Sitemap sections and their part file names.
 *
 * This module deliberately has no imports: the edge middleware loads it on
 * every request, so it must stay dependency-free.
 */
export const SITEMAP_SECTIONS = [
	"pages",
	"products",
	"categories",
	"guides",
	"comparisons",
	"lexicon",
	"calculators",
] as const;

export type SitemapSection = (typeof SITEMAP_SECTIONS)[number];

const SITEMAP_PART_FILE_PATTERN = new RegExp(
	`^(${SITEMAP_SECTIONS.join("|")})(?:-([1-9][0-9]{0,3}))?\\.xml$`,
);

/** `"products.xml"` for an unsplit section, `"products-2.xml"` for its second part. */
export function sitemapPartFileName(section: SitemapSection, part: number | null): string {
	return part === null ? `${section}.xml` : `${section}-${part}.xml`;
}

export function parseSitemapPartFileName(
	file: string,
): { section: SitemapSection; part: number | null } | null {
	const match = SITEMAP_PART_FILE_PATTERN.exec(file);
	if (!match) return null;
	return {
		section: match[1] as SitemapSection,
		part: match[2] ? Number(match[2]) : null,
	};
}

/** Public path of a part file, e.g. `"/sitemaps/products-2.xml"`. */
export function sitemapPartPath(fileName: string): string {
	return `/sitemaps/${fileName}`;
}

export function isSitemapChildPath(pathname: string): boolean {
	return pathname.startsWith("/sitemaps/");
}
